import { render, staticRenderFns } from "./Video.vue?vue&type=template&id=8b5ac9ea&scoped=true&"
import script from "./Video.vue?vue&type=script&lang=js&"
export * from "./Video.vue?vue&type=script&lang=js&"
import style0 from "./Video.vue?vue&type=style&index=0&id=8b5ac9ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b5ac9ea",
  null
  
)

export default component.exports